import React from 'react';

export const optionalCallbackHooks = {
  useHandleClickWithId(
    id: string | null,
    onClick?: (id: string | null) => void,
  ) {
    return React.useCallback(() => {
      if (onClick) {
        onClick(id);
      }
    }, [onClick, id]);
  },
};
